import {store} from '../store/index'
//判断数据类型
export function isType(type, value) {
    return Object.prototype.toString.call(value) === `[object ${type}]`
  }


  export function getIndex() {
    let index = 0;
    let params = location.search && querySearchParams(location.search);
    const {currentKey,currentId} = params;
    if(currentId && currentId !== 'null'){
      index = currentId
    }else if(currentKey && currentKey !== 'null'){
      index = currentKey;
    }
    return index;
  }

 export const querySearchParams = (pathStr) => {
    // var queryStr = location.search.split("?")[1];
    if(!pathStr){
      return {};
    }
    const obj = {};
    const strs = pathStr.split("?")[1];
    const paramt = strs.split("&");

    for (let i = 0; i < paramt.length; i++) {
      let g = paramt[i].split("=");
      obj[g[0]] = g[1];
    }
    return obj;
  };